import { calculatePlanExpiry } from "@memorang/helpers";
import type { Plan } from "@memorang/types";
import { t } from "i18next";
import pluralize from "pluralize";
import createCheckoutSession, {
	type StripeCheckout,
} from "../mutations/createCheckout";

type Params = {
	selectedPlan: Plan;
	productId: string;
	redirectUrl: string;
	productName: string;
	productDescription: string;
};
export const handleCreateCheckoutSession = async ({
	selectedPlan,
	productId,
	redirectUrl,
	productDescription,
}: Params): Promise<string> => {
	const { id: planId } = selectedPlan;

	const checkoutParams: StripeCheckout = {
		productId,
		planId,
		description: productDescription,
		purchaseMode: "USER",
		successUrl: redirectUrl,
		failureUrl: redirectUrl,
		checkoutMode: "EMBED",
	};

	const result = await createCheckoutSession(checkoutParams);
	const clientSecret = result.clientSecret;
	return clientSecret;
};

export const getAccessDurationTemplate = (
	plan?: Plan,
	expiryDate?: string,
	yearPlan?: Plan,
) => {
	if (!plan) {
		return "";
	}
	const isYearPlan = plan.duration === 12;

	if (isYearPlan) {
		return t("purchase.paywall.accesDuration.yearPlan", {
			duration: plan.duration,
			interval: t(`common.${plan.interval}`),
		});
	}

	const expiryText = calculatePlanExpiry(
		plan.interval,
		plan.duration,
		expiryDate,
	);
	return t("purchase.paywall.accesDuration.otherPlan", {
		duration: plan.duration,
		interval: pluralize(t(`common.${plan.interval}`), plan.duration),
		expiryText,
		moreTime: yearPlan
			? t("purchase.paywall.accesDuration.moreTime", {
					yearPlanDuration: yearPlan?.duration,
					yearPlanInterval: t(`common.${yearPlan?.interval}`),
				})
			: "",
	});
};
